// extracted by mini-css-extract-plugin
module.exports = {"siderSection":"style_siderSection__H-Wl4","siderLeft":"style_siderLeft__3iOm8","tabs":"style_tabs__1jcc3","active":"style_active__hcJGi","siderRight":"style_siderRight__1Hj4F"};